import {
  latOfMercatorY,
  lngOfMercatorX,
  mercatorX,
  mercatorY,
} from '../MapBoxViewer/rasterTileMath'
import { textBoxCorners } from './markupTextScale'
import { ITextLayout } from './textMarkupLayout'

// Where a text markup's label may stand, best first: level with the box corner highest on
// screen, for the bearing, so a label lifted from there clears the box at any rotation. First on
// that corner (the left one of an upright box's top edge), then over the box centre, then over
// the other corners. lng/lat: the box centre. groundPerPx: textGroundPerPx at the current zoom.
export function textMarkupLabelSpots(
  lng: number,
  lat: number,
  layout: ITextLayout,
  rotation: number,
  groundPerPx: number,
  bearing: number,
): Array<{ longitude: number; latitude: number }> {
  const b = (bearing * Math.PI) / 180
  const hx = (layout.width / 2) * groundPerPx
  const hy = (layout.height / 2) * groundPerPx
  const tie = (hx + hy) * 1e-9
  // Each corner, by how far it stands screen-up and screen-right of the centre.
  const corners = textBoxCorners(hx, hy, rotation).map(([dx, dy]) => ({
    up: dx * Math.sin(b) - dy * Math.cos(b),
    right: dx * Math.cos(b) + dy * Math.sin(b),
  }))
  const top = corners.reduce((best, corner) =>
    corner.up > best.up + tie ||
    (corner.up > best.up - tie && corner.right < best.right)
      ? corner
      : best,
  )
  const rights = [
    top.right,
    0,
    ...corners
      .filter(corner => corner !== top)
      .sort((a, c) => c.up - a.up)
      .map(corner => corner.right),
  ].filter(
    (right, i, all) =>
      all.findIndex(other => Math.abs(other - right) <= tie) === i,
  )
  const x = mercatorX(lng)
  const y = mercatorY(lat)
  return rights.map(right => ({
    longitude: lngOfMercatorX(x + right * Math.cos(b) + top.up * Math.sin(b)),
    latitude: latOfMercatorY(y + right * Math.sin(b) - top.up * Math.cos(b)),
  }))
}
